module.exports = __webpack_public_path__ + "img/WechatIMG51.99ff1ba6.png";